import styles from './EsqueciSenhaOk.module.css';

const EsqueciSenhaOk = () => {
  return (
    <div className={styles.container}>
      <h2>Foi enviado um link para o seu e-mail.</h2>
      <h4 className={styles.margin}>Acesse seu e-mail e clique no link para ser redirecionado e cadastrar uma nova senha.</h4>
      <h6>(Verifique a Caixa de Entrada e a Caixa de Spam)</h6>
    </div>
  );
};

export default EsqueciSenhaOk;
